module.exports = __webpack_public_path__ + "img/ocps-logo.af7c758c.png";